import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useAutoCaptureFace from './hooks/use-auto-capture-face';
import type { CaptureStatus, Resolution, VideoRef } from './types';
export type AutoCaptureFaceProps = {
  canvasAutoCaptureRef: React.MutableRefObject<HTMLCanvasElement | undefined>;
  feedbackPositionFromBottom: number;
  isCaptured: boolean;
  onDetectionComplete: () => void;
  onDetectionReset: () => void;
  outlineWidth: number;
  setAutoCaptureFeedback: (x?: CaptureStatus) => void;
  videoRef: VideoRef;
  videoSize: Resolution | undefined;
  videoResolution: Resolution | undefined;
};
const AutoCaptureFace = t0 => {
  const $ = _c(11);
  const {
    canvasAutoCaptureRef,
    feedbackPositionFromBottom,
    isCaptured,
    onDetectionComplete,
    onDetectionReset,
    outlineWidth,
    setAutoCaptureFeedback,
    videoRef,
    videoSize,
    videoResolution
  } = t0;
  const t1 = -feedbackPositionFromBottom / 2;
  let t2;
  if ($[0] !== canvasAutoCaptureRef || $[1] !== isCaptured || $[2] !== onDetectionComplete || $[3] !== onDetectionReset || $[4] !== outlineWidth || $[5] !== setAutoCaptureFeedback || $[6] !== t1 || $[7] !== videoRef || $[8] !== videoResolution || $[9] !== videoSize) {
    t2 = {
      canvasRef: canvasAutoCaptureRef,
      isCaptured,
      onDetectionComplete,
      onDetectionReset,
      onStatusChange: setAutoCaptureFeedback,
      outlineOffsetY: t1,
      outlineWidth,
      videoRef,
      videoSize,
      videoResolution
    };
    $[0] = canvasAutoCaptureRef;
    $[1] = isCaptured;
    $[2] = onDetectionComplete;
    $[3] = onDetectionReset;
    $[4] = outlineWidth;
    $[5] = setAutoCaptureFeedback;
    $[6] = t1;
    $[7] = videoRef;
    $[8] = videoResolution;
    $[9] = videoSize;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useAutoCaptureFace(t2);
  return null;
};
export default React.memo(AutoCaptureFace);